const copyToClipboard = async (text) => {
  await navigator.clipboard.writeText(text);
};

export const ClipboardService = {
  copyToClipboard,
};
